export default "__VITE_ASSET__b3135857__"